var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"gewerkt title"},[_c('ogt-video',{ref:"video",attrs:{"src":"/static/video/gewerkt.mp4","poster":"/static/video/gewerkt-poster.jpg"}}),_vm._v(" "),_c('h1',[_vm._v("Hier werkten we aan in 2021")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }